/*
# -----------------------------------------------------------------------------
# Component: treatyAjaxMixin.js
# Author: ssy@pst.sg
# Created Date: 23/Nov/2020
# Comments: Responsible for all backend related calls for RI Header
# -----------------------------------------------------------------------------
*/
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
// import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { formatDisplayDateTime2 } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'

export const treatyAjaxMixin = {
  data() {
    return {
    }
  },
  computed: {
    mode() {
      return this.$route.params.mode
    }
  },
  methods: {
    doColumn(riTab, ttyHeaderForm) {
      this.tab = undefined
      this.columns = []
      // console.log(this.ttyHeaderForm)
      if (riTab === 'ttyStmtLn') {
        this.tab = 'ttyStmtLn'
        this.columns = Object.assign(this.columns, this.ttyStmtLnColumns)
      }
      // console.log(this.ttyStmtLnForm)
      // console.log(this.retroRIList)
      // this.getTtyStmtLnList(this.ttyHeaderForm)
      // this.getCedCoCedBrk(this.ttyHeaderForm, this.ttyStmtLnForm)
      if (this.retroRIList.length === 1) {
        this.getRetroRIList(ttyHeaderForm)
      }
      if (this.ttyHeaderForm.ttyRef !== '' && this.ttyHeaderForm.ttyRef !== undefined) {
        this.getTtyStmtLnList(this.ttyHeaderForm)
        if (this.ttyStmtLnForm.riRef !== undefined && this.ttyStmtLnForm.brkRef !== undefined) {
          this.getCedCoCedBrk(this.ttyHeaderForm, this.ttyStmtLnForm)
        }
      }
    },
    async getMiscTreatyParam() {
      const apiUrl = this.menu.getMiscTreatyParam
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            // console.log(data)
            this.miscTreatyParam.perSuspTran = data.miscTreaty.perSuspTran
            this.miscTreatyParam.perDebtTran = data.miscTreaty.perDebtTran
            // this.miscTreatyParam.nxtInwTranRef = data.miscTreaty.nxtInwTranRef
            // this.miscTreatyParam.nxtOutwTranRef = data.miscTreaty.nxtOutwTranRef
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getTtyStmtLnList(ttyHeaderForm) {
      const apiUrl = this.menu.treatyStmtLnList
      if (apiUrl) {
        try {
          this.loading = true
          this.ttyStmtLnList = []
          const { page, itemsPerPage } = this.paginationTtyStmtLn
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            riType: ttyHeaderForm.riType,
            ttyRef: ttyHeaderForm.ttyRef,
            stmtType: ttyHeaderForm.stmtType,
            tranRef: ttyHeaderForm.tranRef,
            stmtLnSeq: ttyHeaderForm.stmtLnSeq
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.ttyStmtLnFilter, this.paginationTtyStmtLn.sortBy, this.paginationTtyStmtLn.sortDesc))
          if (result.data) {
            this.totalItemsTtyStmtLn = result.data.totalElements
            const { data } = result.data
            if (data) {
              // console.log(data)
              data.map(ttyStmtLn => {
                const convertTtyStmtLn = {
                  riType: ttyStmtLn.riType,
                  ttyRef: ttyStmtLn.ttyRef,
                  stmtType: ttyStmtLn.stmtType,
                  tranDate: ttyStmtLn.tranDate,
                  tranDateDisp: this.formatDate(ttyStmtLn.tranDate),
                  acctYr: ttyStmtLn.acctyr,
                  acctMth: ttyStmtLn.acctMth,
                  riRef: ttyStmtLn.riRef,
                  brkRef: ttyStmtLn.brkRef,
                  uwYr: ttyStmtLn.uwYr,
                  stmtLnType: ttyStmtLn.stmtLnType,
                  stmtLnSeq: ttyStmtLn.stmtLnSeq,
                  busAn: ttyStmtLn.busAn,
                  busAnDesc: ttyStmtLn.busAnDesc,
                  tranRef: ttyStmtLn.tranRef,
                  amtA: ttyStmtLn.amtA,
                  aedA: ttyStmtLn.aedA,
                  amt1A: ttyStmtLn.amt1A,
                  amt2A: ttyStmtLn.amt2A,
                  amt3A: ttyStmtLn.amt3A,
                  amt4A: ttyStmtLn.amt4A,
                  amt5A: ttyStmtLn.amt5A,
                  amt6A: ttyStmtLn.amt6A,
                  acctNoSfx: ttyStmtLn.acctNoSfx
                }
                this.ttyStmtLnList.push(convertTtyStmtLn)
              })
              // console.log(this.ttyStmtLnList)
            } else {
              this.ttyStmtLnList = []
            }
            // this.$store.commit(TTY_STMT_LN, this.ttyStmtLnList)
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getCedCoCedBrk(ttyHeader, ttyStmtLn) {
      const apiUrl = this.menu.getCedCoCedBrk
      if (apiUrl) {
        try {
          const params = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            uwYr: ttyHeader.uwYr,
            riRef: ttyStmtLn.riRef,
            brkRef: ttyStmtLn.brkRef
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            // console.log(data)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getRetroRIList(ttyHeader) {
      const apiUrl = this.menu.getRetroRIList
      if (apiUrl) {
        try {
          const expand = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            uwYr: ttyHeader.uwYr
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          // const { data } = result.data
          if (result.data.dataList) {
            result.data.dataList.map(retroRI => {
              const convertList = {
                text: retroRI.label,
                value: retroRI.value
              }
              this.retroRIList.push(convertList)
            })
            // this.retroRIList.push(result.data.dataList)
            // this.$push(this, 'retroRIList', result.data.dataList)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchTtyStmtLn(ttyStmtLn) {
      const apiUrl = this.menu.getTtyStmtLnDetail
      if (apiUrl) {
        try {
          const params = {
            riType: ttyStmtLn.riType,
            ttyRef: ttyStmtLn.ttyRef,
            stmtType: ttyStmtLn.stmtType,
            tranDate: formatDisplayDateTime2(ttyStmtLn.tranDate),
            riRef: ttyStmtLn.riRef,
            brkRef: ttyStmtLn.brkRef,
            uwYr: ttyStmtLn.uwYr,
            stmtLnType: ttyStmtLn.stmtLnType,
            busAn: ttyStmtLn.busAn,
            tranRef: ttyStmtLn.tranRef
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            this.ttyStmtLnForm.riRef = data.ttyStmtLn.riRef
            this.ttyStmtLnForm.acctNoSfx = data.ttyStmtLn.acctNoSfx
            this.ttyStmtLnForm.brkRef = data.ttyStmtLn.brkRef
            this.ttyStmtLnForm.uwYr = data.ttyStmtLn.uwYr
            this.ttyStmtLnForm.stmtLnType = data.ttyStmtLn.stmtLnType
            this.ttyStmtLnForm.stmtLnSeq = data.ttyStmtLn.stmtLnSeq
            this.ttyStmtLnForm.busAn = data.ttyStmtLn.busAn
            this.ttyStmtLnForm.amtA = data.ttyStmtLn.amtA
            this.ttyStmtLnForm.aedA = data.ttyStmtLn.aedA
            this.ttyStmtLnForm.amt1A = data.ttyStmtLn.amt1A
            this.ttyStmtLnForm.amt2A = data.ttyStmtLn.amt2A
            this.ttyStmtLnForm.amt3A = data.ttyStmtLn.amt3A
            this.ttyStmtLnForm.amt4A = data.ttyStmtLn.amt4A
            this.ttyStmtLnForm.amt5A = data.ttyStmtLn.amt5A
            this.ttyStmtLnForm.amt6A = data.ttyStmtLn.amt6A
            this.ttyStmtLnForm.amt1ALoc = data.ttyStmtLn.amt1ALoc
            this.ttyStmtLnForm.amt2ALoc = data.ttyStmtLn.amt2ALoc
            this.ttyStmtLnForm.amt3ALoc = data.ttyStmtLn.amt3ALoc
            this.ttyStmtLnForm.amt4ALoc = data.ttyStmtLn.amt4ALoc
            this.ttyStmtLnForm.amt5ALoc = data.ttyStmtLn.amt5ALoc
            this.ttyStmtLnForm.amt6ALoc = data.ttyStmtLn.amt6ALoc
            this.ttyStmtLnForm.amtB = data.ttyStmtLn.amtB
            this.ttyStmtLnForm.aedB = data.ttyStmtLn.aedB
            this.ttyStmtLnForm.amt1B = data.ttyStmtLn.amt1B
            this.ttyStmtLnForm.amt2B = data.ttyStmtLn.amt2B
            this.ttyStmtLnForm.amt3B = data.ttyStmtLn.amt3B
            this.ttyStmtLnForm.amt4B = data.ttyStmtLn.amt4B
            this.ttyStmtLnForm.amt5B = data.ttyStmtLn.amt5B
            this.ttyStmtLnForm.amt6B = data.ttyStmtLn.amt6B
            this.ttyStmtLnForm.amt1BLoc = data.ttyStmtLn.amt1BLoc
            this.ttyStmtLnForm.amt2BLoc = data.ttyStmtLn.amt2BLoc
            this.ttyStmtLnForm.amt3BLoc = data.ttyStmtLn.amt3BLoc
            this.ttyStmtLnForm.amt4BLoc = data.ttyStmtLn.amt4BLoc
            this.ttyStmtLnForm.amt5BLoc = data.ttyStmtLn.amt5BLoc
            this.ttyStmtLnForm.amt6BLoc = data.ttyStmtLn.amt6BLoc
            this.ttyStmtLnForm.amtC = data.ttyStmtLn.amtC
            this.ttyStmtLnForm.aedC = data.ttyStmtLn.aedC
            this.ttyStmtLnForm.amt1C = data.ttyStmtLn.amt1C
            this.ttyStmtLnForm.amt2C = data.ttyStmtLn.amt2C
            this.ttyStmtLnForm.amt3C = data.ttyStmtLn.amt3C
            this.ttyStmtLnForm.amt4C = data.ttyStmtLn.amt4C
            this.ttyStmtLnForm.amt5C = data.ttyStmtLn.amt5C
            this.ttyStmtLnForm.amt6C = data.ttyStmtLn.amt6C
            this.ttyStmtLnForm.amt1CLoc = data.ttyStmtLn.amt1CLoc
            this.ttyStmtLnForm.amt2CLoc = data.ttyStmtLn.amt2CLoc
            this.ttyStmtLnForm.amt3CLoc = data.ttyStmtLn.amt3CLoc
            this.ttyStmtLnForm.amt4CLoc = data.ttyStmtLn.amt4CLoc
            this.ttyStmtLnForm.amt5CLoc = data.ttyStmtLn.amt5CLoc
            this.ttyStmtLnForm.amt6CLoc = data.ttyStmtLn.amt6CLoc
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getStmtLnTypeDropList() {

    },
    async doCreateTtyStmtLn() {
      const apiUrl = this.menu.createTtyStmtLn
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiUrl, this.ttyStmtLnForm)
          const { data } = result.data
          if (data) {
            // console.log(data)
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdateTtyStmtLn() {
      const apiUrl = this.menu.updateTtyStmtLn
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiUrl, this.ttyStmtLnForm)
          const { data } = result.data
          if (data) {

          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCreateTtyStmtLn2(ttyHeader) {
      const apiUrl = this.menu.createTtyStmtLn2
      if (apiUrl) {
        try {
          const expand = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            stmtType: ttyHeader.stmtType,
            tranDate: formatDisplayDateTime2(ttyHeader.tranDate),
            tranRef: ttyHeader.tranRef,
            createdProgID: ttyHeader.createdProgID
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            // console.log(data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
